import React from 'react';

import { Button, Image } from 'react-bootstrap';
import { getInitials, getStatusIcon } from '../services/function';

import iconUserChat from '../assets/icon/userChat.svg';
import Users from '../interfaces/IUsers';
import UserDepartament from './UserDepartament';
import { userStatus } from '../enums/userStatus';

const UserChatGroupList: React.FC<{
  users: Users[];
  addChat: (seqGrupo: number, seqUsuario: number) => void;
}> = ({ users, addChat }) => {
  return (
    <div className="d-flex w-100 pb-1">
      <div
        className="card position-static ms-1 table-responsive overflow-hidden"
        style={{
          width: '100%',
          borderRadius: '0.68rem',
          boxShadow: '0px 4px 4px 1px rgba(0, 0, 0, 0.25)',
        }}
      >
        <div
          className="table-responsive overflow-hidden"
          style={{
            borderTopLeftRadius: '0.68rem',
            borderTopRightRadius: '0.68rem',
            borderColor: 'transparent',
            backgroundColor: '#1A1A1A',
            fontSize: '1.25rem',
          }}
        >
          <span
            style={{
              color: '#fff',
              fontSize: '1.58rem',
              marginLeft: '0.6rem',
            }}
          >
            Usuários
          </span>
        </div>
        <div
          className="w-100 overflow-auto"
          style={{
            flex: 1,
          }}
        >
          <div className="d-flex flex-column" style={{ height: '100px' }}>
            <table className="table table-nowrap mb-0 table-striped-custom table-hover">
              <thead
                style={{
                  fontSize: '1.25rem',
                  fontWeight: '600',
                  backgroundColor: '#D1D1D1',
                }}
                className="position-sticky top-0 z-index-modal"
              >
                <tr>
                  <th style={{ width: '30rem' }}>Nome</th>
                  <th colSpan={2} style={{ width: '40rem' }}>
                    Departamentos
                  </th>
                </tr>
              </thead>
              <tbody className="overflow-auto">
                {users
                  .sort((a, b) => {
                    if (a.status === b.status) {
                      return a.nomeUsuario.localeCompare(b.nomeUsuario); // Ordena por nome se o status for igual
                    }
                    return a.status - b.status; // Ordena por status em ordem crescente
                  })
                  .map((user) => (
                    <tr
                      key={user.seqUsuario}
                      className="cursor-pointer hover inner-row-hover"
                      onDoubleClick={() => addChat(0, user.seqUsuario)}
                      style={{ cursor: 'pointer' }}
                    >
                      <td style={{ width: '30rem' }}>
                        <div className="d-flex position-relative align-items-center mb-1">
                          <div
                            style={{
                              width: '3.25rem',
                              height: '3.25rem',
                              marginTop: '0.2rem',
                              marginLeft: '0.5rem',
                              backgroundColor:
                                user.cor === '' || !user.cor
                                  ? '#616161'
                                  : user.cor,
                              borderRadius: '0.6875rem',
                            }}
                            className="d-flex align-items-center justify-content-center"
                          >
                            <span
                              style={{
                                color: '#fff',
                                fontSize: '1.5rem',
                                textAlign: 'center',
                                fontWeight: '600',
                                wordWrap: 'break-word',
                              }}
                            >
                              {getInitials(user.nomeUsuario)}
                            </span>
                          </div>

                          {user.status !== userStatus.Invisivel && (
                            <Image
                              className="position-absolute"
                              style={{
                                top: '2.7rem',
                                left: '3rem',
                                height: '1.4rem',
                                width: '1.4rem',
                              }}
                              src={getStatusIcon(user.status)}
                              alt="Online"
                            />
                          )}
                          <span
                            style={{
                              fontSize: '1.25rem',
                              marginLeft: '0.6rem',
                            }}
                          >
                            {user.nomeUsuario}
                          </span>
                        </div>
                      </td>
                      <td style={{ width: '45rem' }}>
                        <div>
                          <UserDepartament
                            userDepartament={user.departamento}
                            alignContent="justify-content-start"
                          />
                        </div>
                      </td>
                      <td className="text-end pe-2">
                        <Button
                          className="p-0 m-0"
                          style={{
                            height: '2.1rem',
                            width: '2.1rem',
                          }}
                          onClick={() => addChat(0, user.seqUsuario)}
                        >
                          <img
                            src={iconUserChat}
                            style={{
                              height: '1.8rem',
                              width: '1.8rem',
                            }}
                            alt="chat"
                          />
                        </Button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserChatGroupList;
